import { createAction } from 'Lib/reduxUtils';

import {
  LOCATION_PERMISSION_DENIED,
  LOCATION_PERMISSION_DISMISS,
  LOCATION_PERMISSION_GRANTED,
  LOCATION_TIMEOUT,
  LOCATION_TIMESTAMP_UPDATE,
  LOCATION_UPDATE,
  LOCATION_UPDATE_FAILURE,
} from './constants';
import type { Position } from './types';

export const locationPermissionDenied = createAction(
  LOCATION_PERMISSION_DENIED,
  (err?: GeolocationPositionError) => err
);
export const locationPermissionGranted = createAction(LOCATION_PERMISSION_GRANTED);
export const locationTimeout = createAction(LOCATION_TIMEOUT);
export const locationTimestampUpdate = createAction(
  LOCATION_TIMESTAMP_UPDATE,
  (timestamp: number) => timestamp
);
export const locationUpdate = createAction(LOCATION_UPDATE, (position: Position) => position);
export const locationUpdateFailure = createAction(
  LOCATION_UPDATE_FAILURE,
  (err?: GeolocationPositionError) => err
);
export const locationPermissionDismiss = createAction(LOCATION_PERMISSION_DISMISS);
